import {Outlet} from "react-router-dom";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import TranslationScope from "../../translation/translation-scope";
import {useEffect, useState} from "react";
import currentPortalStore from "../../stores/current-portal-store";
import {FEATURES} from "../../models/Plan";
import {observer} from "mobx-react-lite";
import useExpandCollapse from '../../hooks/expand-collapse-hook';
import emailContentListStore from './stores/email-content-list-store';
import emailCustomizationStore from "./stores/email-customization-store";
import { APP_PATHS } from "../../constants/app-paths";
import TranslateButtonSPA from "../../components/translate-button/TranslateButtonSPA";

const PageOutlet: React.FC = observer(() => {

    const expandCollapseStore = useExpandCollapse();

    useEffect(() => {
        currentPortalStore.load();
        emailCustomizationStore.load();
        emailContentListStore.load();
    });

    return (
        <Outlet context={expandCollapseStore} />
    );
});


const EmailContentPage: React.FC = observer(() => {

    const [showTranslationButtons, setShowTranslationButtons] = useState<boolean>(false);
    emailContentListStore.setIsShowTranslationButtons(setShowTranslationButtons);

    return (
        <TranslationScope scope="pending-approval-email">
            <BasePageLayout title="Settings"
                instruction={
                        <>
                            {emailContentListStore.selectedEvent?.description ?? "Customize the notifications that are sent to customers."}
                        </>
                }
            >
                {showTranslationButtons &&
                    <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 0 10px 0', gap: 20 }}>
                    <TranslateButtonSPA 
                        text="Translate returns emails" 
                        path={APP_PATHS.EMAILS_LOCALIZATION}
                    />
                    {currentPortalStore.isFeatureAllowed(FEATURES.ORDER_TRACKING) &&
                        <TranslateButtonSPA 
                            text="Translate order tracking emails" 
                            path={APP_PATHS.TRACKING_EMAILS_LOCALIZATION}
                        />
                    }
                </div>
                }
                 <PageOutlet />
            </BasePageLayout>
        </TranslationScope>
    );
});

export default EmailContentPage;